import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { StockRoutingModule } from './stock-routing.module';
import { DashboardStockComponent } from './list/dashboard-stock/dashboard-stock.component';
import { ListStockComponent } from './list/list-stock.component';
import { StockFormComponent } from './stock-form/stock-form.component';
import { FilterDialogComponent } from './filter-dialog/filter-dialog.component';
import { StockComponent } from './stock.component'; // Caminho conforme acima
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import {
  MatRippleModule,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

@NgModule({
  declarations: [
    StockComponent,
    DashboardStockComponent,
    ListStockComponent,
    StockFormComponent,
    FilterDialogComponent,
  ],
  imports: [
    CommonModule,
    StockRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    MatTooltipModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatSelectModule,
    MatMomentDateModule,
    MatDatepickerModule,
    //MatNativeDateModule,
    NgApexchartsModule,
  ],
  providers: [
      {
        provide: MAT_DATE_FORMATS,
        useValue: {
          parse: {
            //dateInput: moment.ISO_8601,
            dateInput: 'DD/MM/YYYY',
          },
          display: {
            //dateInput: 'DD/MM/YY',
            dateInput: 'DD/MM/YYYY',
            monthYearLabel: 'MMM YYYY',
            dateA11yLabel: 'DD/MM/YYYY',
            monthYearA11yLabel: 'MMMM YYYY',
          },
        },
      },
      { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
      { provide: MAT_DIALOG_DATA, useValue: {} },
  ],
  exports: [DashboardStockComponent, ListStockComponent, StockFormComponent],
})
export class StockModule {}
